import { useEffect, useState, useRef } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { usePageTracker } from 'libs/searchspring/hooks/usePageTracker'
import { useOption } from 'libs/searchspring/hooks/useOption'
import { useMerchedResults } from 'libs/searchspring/hooks/useMerchedResults'

export function useInfiniteScrollResults() {
  const { results, options, isLoading: fetchLoading, refine } = useSearchspringContext()

  const [merchandisingBanners, setMerchandisingBanners] = useState([])

  useEffect(() => {
    if (results?.merchandising?.content) {
      const bannerObject = {
        header: results.merchandising.content.header || [],
        footer: results.merchandising.content.footer || [],
        banner: results.merchandising.content.banner || []
      }
      setMerchandisingBanners(bannerObject)
    }
  }, [results?.merchandising?.content])

  // Used to track the current page and loaded pages for determining where to insert new results
  const { loadedPages, page } = usePageTracker()
  // Initialise pageOption to sync with URL
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const pageOption = useOption('page', { defaultValue: 1, syncWithURL: true })

  // Used to store combined results after pagination
  const [allResults, setAllResults] = useState([])
  // Used to track updates to the grid contents to trigger scroll keeping
  const [gridChange, setGridChange] = useState()
  // Used to track the first successful fetch for accurate loading checks
  const hasBeenLoading = useRef(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!isLoading && hasBeenLoading.current) {
      hasBeenLoading.current = false
    }

    if (hasBeenLoading.current) {
      setIsLoading(fetchLoading)
      return
    }

    if (fetchLoading) {
      hasBeenLoading.current = true
      setIsLoading(true)
    }
  }, [fetchLoading])

  const merchedResults = useMerchedResults()

  useEffect(() => {
    if (loadedPages.length === 0 || (loadedPages.length === 1 && loadedPages[0] === page) || page === undefined) {
      // Initial load
      setGridChange({
        type: 'initial'
      })
      setAllResults(merchedResults)
    } else if (page < loadedPages[0]) {
      // Page changed to previous page
      setGridChange({
        type: 'prev'
      })
      setAllResults((prev) => [...merchedResults, ...prev])
    } else if (page > loadedPages[loadedPages.length - 1]) {
      // Page changed to next page
      setGridChange({
        type: 'next'
      })
      setAllResults((prev) => [...prev, ...merchedResults])
    }
  }, [merchedResults])

  return { allResults, merchandisingBanners, gridChange, isLoading, options, results, refine }
}
